export default function extractData(countries, ds, paramObj, category, sizes) {
    const config = require ('../../../../configs/configuration.js')
    const constants = config.configuration.data;
    'use strict';

    let collection = {};
    let data = [];
    const timeIndicators = indicators[category].periods;
    const grouping = indicators[category].grouping;

    var arrayNoData = [];
   // console.log(grouping);
    var value = 0;
   

    for (var country of countries) {
        // collection[country] = country;
        paramObj.geo = country;
        var times = [];  
        for (var time of timeIndicators) {
            var value = {}; 
            var total = 0;
            var calculatedTotal = 0;
            data = [];
            var hasUndefined = false; 

            if (grouping.process == "CALCULATEDTOTAL%") {
                for (var groupIndex in grouping.groups) {
                    var groupCode = grouping.groups[groupIndex].code;
                    value.year = time;  
                    value.Geo = country;
                    const paramsType = grouping.groups[groupIndex].elems;
                    var sum = 0;
    
                    for (var paramItem in paramsType) {
                        paramObj.time = time;
                        paramObj[grouping.paramName] = paramsType[paramItem];

                        const valueTmp = ds.Data(paramObj).value;
                        if (valueTmp != undefined) {
                            calculatedTotal+= parseFloat(valueTmp)
                        }
                    }
                }
            }

            
            for (var groupIndex in grouping.groups) {
                var groupCode = grouping.groups[groupIndex].code;
                value.year = time;  
                value.Geo = country;
                const paramsType = grouping.groups[groupIndex].elems;
                var sum = 0;


                for (var paramItem in paramsType) {
                    paramObj.time = time;
                    paramObj[grouping.paramName] = paramsType[paramItem];

                    const valueTmp = ds.Data(paramObj).value;
                    //console.log("value country : "+country+"  :  "+valueTmp);
                    if (valueTmp == undefined) {
                        hasUndefined = true;
                       
                    }else {
                        sum += parseFloat(valueTmp);
                    }
                    /*
                    console.log("***************");
                    console.log("Country = "+country+"   Param = "+grouping.paramName+" value = "+paramsType[paramItem]+"   value = "+valueTmp+"   Sum  = "+sum);
                    */
                }
                if (grouping.process == "TOTAL%" || grouping.process == "CALCULATEDTOTAL%") {
                    //console.log("%total");
                    var valueTot;
                    if (grouping.process == "CALCULATEDTOTAL%") {
                        valueTot = calculatedTotal;
                    }else {
                        paramObj[grouping.paramName] = "TOTAL";
                        valueTot = ds.Data(paramObj).value;
                    }
                    if (grouping.groups[groupIndex].process) {
                        if (grouping.groups[groupIndex].process == "TOTAL-") {
                            sum = ((valueTot - sum)/valueTot)*100;
                        }
                    }else {
                        sum = (sum/valueTot)*100;
                    }
                    /*
                    console.log("Process = "+grouping.process);
                    console.log("Sum = "+sum);
                    console.log("Total = "+valueTot); 
                    console.log("Calculated Total = "+calculatedTotal); 
                    console.log("Sum % = "+sum);
                    */
                }
  
                if (indicators[category].showWithUndefined) {
                    //console.log("show With undefined");
                    value[groupCode] = sum;
                }else {
                    value[groupCode] = hasUndefined ? undefined : sum;
                }
                
                //value[groupCode] = sum;
         
                total+= sum;
                value.Total = total;
                
                data = value;

            } 
            if (hasUndefined) {
               // console.log ("Undefined = "+country);
               // console.log(data);
            }
            if (hasUndefined == false || indicators[category].showWithUndefined) {
                //console.log("add data "+ country);
                collection[country] = data; 
            }else {

                arrayNoData.push(country);
            }
        }

        data = [];
    }
    if (indicators[category].calculateEU) {
        var calculatedEU = {};
        var value = {}; 
        var total = 0;
        for (var country of indicators[category].calculateEU.countries) {
            // collection[country] = country;
            paramObj.geo = country;
            var times = [];  
            for (var time of timeIndicators) {
   
      

                var sum;
                var hasUndefined = false;
                for (var groupIndex in grouping.groups) {
                    var groupCode = grouping.groups[groupIndex].code;
                    value.year = time;  
                    value.Geo = country;
                    const paramsType = grouping.groups[groupIndex].elems;
                    var sum = 0;
                    for (var paramItem in paramsType) {
                        paramObj.time = time;
                        paramObj[grouping.paramName] = paramsType[paramItem];
    
                        const valueTmp = ds.Data(paramObj).value;
                        if (valueTmp == undefined) {
                            hasUndefined = true;
                        }else {
                            sum += parseFloat(valueTmp);
                        }
                    }
    
                    data[groupCode] = data[groupCode] == undefined ? sum: data[groupCode] + sum;
                    //console.log("********* "+country+"  : "+sum+"   *******  Total : "+total+"  *****");
                    //console.log(data);
    
                } 
                paramObj[grouping.paramName] = "TOTAL";
                const totalTmp = ds.Data(paramObj).value;
                total+= totalTmp;

            }
        }
        data.Geo = indicators[category].calculateEU.code;
        data.Total = total;
        //console.log("After loop");
        //console.log(data);
        calculatedEU = data;

        if (grouping.process == "TOTAL%") {
            const paramsType = grouping.groups[0].elems;
            for (var key in data) {
                if (key != "year" && key != "Geo" && key != "Total") {
                data[key] = data[key]/data["Total"]*100;
                }
            }
            data["Total"] = 100;

        }
        var collectionTmp = collection;
        var code = indicators[category].calculateEU.code;
        collection = {code : data};
        for (var strKey in collectionTmp) {
            collection[strKey] = collectionTmp[strKey];
        }
        //console.log(collection);
        //console.log(data);
        //collection.push(...collectionTmp);
        //collection["EU28"] = data; 

    }
    //console.log("Data processed")
    //console.log(collection);
    collection.time = timeIndicators;
    if (window.parent !== window && window.parent.disableCountries) { 
        window.parent.disableCountries(arrayNoData)
      }
    return collection;
}
 